<template>
  <v-row no-gutters class="map-address-search my-0" style="width: 250px">
    <v-col class="pa-0" cols="10">
      <v-menu
        v-model="isSearchHintsVisible"
        min-width="250px"
        nudge-bottom="32"
        nudge-left="0"
        :close-on-content-click="false"
        :close-on-click="false"
        :open-on-click="false"
      >
        <template #activator="{ on }">
          <v-text-field
            ref="searchInput"
            v-on="on"
            height="32"
            class="py-0 px-0 ma-0 included-search"
            solo
            dense
            hide-details
            :loading="loading"
            v-model="addressSearchInput"
            @focus="onFocus"
            @input="search"
            @keydown.enter="find"
            :placeholder="$i18n.t('default.search')"
          />
        </template>
        <v-list
          v-if="addressSearchInput && !loading"
          v-click-outside="{
            handler: onClickOutside,
            include,
            closeConditional
          }"
        >
          <template v-if="items.length > 0">
            <v-list-item class="search-list-item" @click="setObject(item)" v-for="(item, key) of items" :key="key">{{
              item.label
            }}</v-list-item>
          </template>
          <template v-else>
            <v-list-item class="search-list-item font-italic">{{ $i18n.t('default.noHints') }}</v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-col>
    <v-col class="pa-0" cols="2">
      <v-btn
        depressed
        block
        dark
        x-small
        color="primary"
        :title="$i18n.t('default.search')"
        class="map-address-search-button px-2"
        :loading="loading"
        @click="find"
      >
        <v-icon class="title">mdi-magnify</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import { debounce } from 'lodash';
import { transform } from 'ol/proj';
export default {
  data: () => ({
    addressSearchInput: '',
    isSearchHintsVisible: false,
    items: [],
    loading: false
  }),
  methods: {
    async find() {
      this.items = [];
      this.loading = true;
      if (!this.addressSearchInput) {
        this.$emit('clear');
        this.loading = false;
        return;
      }
      try {
        await this.$store.dispatch('addressSearch', this.addressSearchInput).then(r => {
          if (r.data.data.length > 0) {
            this.onClickOutside();
            this.$refs.searchInput.blur();
            this.items = r.data.data;
            const firstObject = r.data.data[0];
            this.drawMarker(firstObject);
          } else {
            this.$root.$emit('showSnackbar', this.$i18n.t(`default.noResults`));
            this.$emit('clear');
          }
          this.loading = false;
        });
      } catch {
        this.loading = false;
      }
    },
    async search() {
      this.items = [];
      this.loading = true;
      if (!this.addressSearchInput) {
        this.loading = false;
        return;
      }
      try {
        await this.$store.dispatch('addressSearch', this.addressSearchInput).then(r => {
          this.items = r.data.data;
          this.loading = false;
        });
      } catch {
        this.loading = false;
      }
    },
    clear() {
      this.$emit('clear');
    },
    closeConditional() {
      return this.isSearchHintsVisible;
    },
    drawMarker(object) {
      const transformCoordsB = transform(object.coords, 'EPSG:4326', 'EPSG:3857');
      this.$emit('search', transformCoordsB);
    },
    include() {
      return [document.querySelector('.included-search')];
    },
    onClickOutside() {
      this.isSearchHintsVisible = false;
    },
    onFocus() {
      this.isSearchHintsVisible = true;
    },
    setObject(object) {
      this.addressSearchInput = object.label;
      this.isSearchHintsVisible = false;
      this.items = [object];
      this.drawMarker(object);
    }
  },
  created() {
    this.search = debounce(this.search, 500);
  }
};
</script>
<style lang="scss">
.map-address-search {
  position: absolute;
  z-index: 5;
  left: 15px;
  top: 10px;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
}
.map-address-search-button {
  height: 100% !important;
  border-radius: 0 5px 5px 0;
}
.v-text-field > .v-input__control > .v-input__slot::before {
  border: 0px;
}
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 0px !important;
}
.v-input {
  font-size: 14px;
  border-radius: 5px 0 0 5px;
}
input {
  padding-left: 0 !important;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.search-list-item {
  min-height: 32px;
  height: 32px;
  font-size: 14px;
}
</style>